/**
 * `products.pizza_ingredient_ids` as a list — §9.190.
 *
 * Stored as a JSON array of ids, which is what legacy writes. Anything else reads as *none chosen*
 * rather than throwing: a product row written by hand or by an older client must not break the editor
 * that has to fix it.
 */
export function parseIngredientIds(raw: unknown): number[] {
  if (Array.isArray(raw)) return raw.filter((id): id is number => typeof id === 'number')
  if (typeof raw !== 'string' || raw.trim() === '') return []
  try {
    const parsed = JSON.parse(raw) as unknown
    return Array.isArray(parsed) ? parsed.filter((id): id is number => typeof id === 'number') : []
  } catch {
    return []
  }
}
